import { render } from "./xfs.vue?vue&type=template&id=0827a28a&scoped=true"
import script from "./xfs.vue?vue&type=script&lang=js"
export * from "./xfs.vue?vue&type=script&lang=js"

import "./xfs.vue?vue&type=style&index=0&id=0827a28a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0827a28a"]])

export default __exports__